export default {
  'hero.badge': 'XR × AI × HCI / Industrial DX & Democratization',
  'hero.name': 'Keitaro Shimizu',
  'hero.nameEn': 'Keitaro Shimizu',
  'hero.title': 'CEO, Play Life Studio  /  Ph.D Candidate, The University of Tokyo (HCI)',
  'hero.description': 'Designing human-centered XR, AI, and Digital Twin systems for people and society — democratized, and built to be used.',
  'hero.imageAlt': 'Profile photo of Keitaro Shimizu',
};
